<template>
  <div>
    <VAutocomplete
      v-model="data.products"
      :label="$t('forms.labels.products')"
      :items="displayedProducts"
      :rules="{ required: true }"
      outlined
      multiple
      data-cy="associateProducts_Products"
      :loading="productsLoading"
    />
    <VAutocomplete
      v-if="!isViewFromSite"
      v-model="data.sites"
      :label="$t('forms.labels.sites')"
      :items="displayedSites"
      :rules="{ required: true }"
      multiple
      :loading="sitesLoading"
    />
  </div>
</template>

<script>
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        associatedProductIds: {
            type: Array,
            default: () => [],
        },
        clientId: {
            type: String,
            required: true,
        },
        isViewFromSite: {
            type: Boolean,
            default: false,
        },
        site: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            productsLoading: false,
            sitesLoading: false,
            availableProducts: [],
            availableSites: [],
            data: {
                products: [],
                sites: [],
            },
        };
    },
    computed: {
        displayedProducts() {
            return this.availableProducts.map(({ id, name, code }) => ({
                name: `${name} [${code}]`,
                id,
                disabled: this.associatedProductIds.includes(id),
            }));
        },
        displayedSites() {
            return this.availableSites.map(({ id, name, deliveryAccountNumber }) => ({
                name: `${name} [${deliveryAccountNumber}]`,
                id,
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('sendData', this.data);
            },
            deep: true,
        },
    },
    async created() {
        await Promise.all([
            this.loadProducts(),
            this.loadSites(),
        ]);
    },
    methods: {
        async loadProducts() {
            this.productsLoading = true;
            const { data } = await this.$rq.getProducts();
            this.availableProducts = data.products;
            this.productsLoading = false;
        },
        async loadSites() {
            if (this.site) {
                return;
            }

            this.sitesLoading = true;
            const { data } = await this.$rq.getClientSites(this.clientId);
            this.availableSites = data.sites;
            this.sitesLoading = false;
        },
    },
};
</script>
